import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";
import { RESPONSEBASE, RESPONSEPAYMENTCARDCREATE, RESPONSEPAYMENTCARDSUCCESS } from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchPaymentCardAuthService,
  fetchPaymentCardConfirmService,
  fetchPaymentCardCreateService,
} from "../../services/payment-card.service";
import {
  fetchPaymentCardAuthorizationFailure,
  fetchPaymentCardAuthorizationSuccess,
  fetchPaymentCardConfirmFailure,
  fetchPaymentCardConfirmSuccess,
  fetchPaymentCardCreateFailure,
  fetchPaymentCardCreateSuccess,
} from "./actions";
import {
  FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_REQUEST,
  FETCH_PAYMENT_CARD_CONFIRM_REQUEST,
  FETCH_PAYMENT_CARD_CREATE_REQUEST,
} from "./actions.type";
import { FetchPaymentCardAuthorizationRequest, FetchPaymentCardCreateRequest } from "./types";

function* fetchPaymentCardCreateSaga(action: FetchPaymentCardCreateRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<any> = yield call(() => fetchPaymentCardCreateService(action.payload));
    console.log("fetchPaymentCardCreate response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      const data: RESPONSEPAYMENTCARDCREATE = response?.data;
      yield put(fetchPaymentCardCreateSuccess(data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchPaymentCardCreateFailure());
    getErrorMessage(e, true);
  }
}

function* fetchPaymentCardConfirmSaga() {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchPaymentCardConfirmService);
    console.log("fetchPaymentCardConfirm response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.verification;
      yield put(fetchPaymentCardConfirmSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchPaymentCardConfirmFailure());
    getErrorMessage(e, true);
  }
}

function* fetchPaymentCardAuthSaga(action: FetchPaymentCardAuthorizationRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<any> = yield call(() => fetchPaymentCardAuthService(action));
    console.log("fetchPaymentCardAuth response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      const data: RESPONSEPAYMENTCARDSUCCESS = response.data;
      yield put(fetchPaymentCardAuthorizationSuccess(data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchPaymentCardAuthorizationFailure(getErrorEndOTP(e)));
    getErrorMessage(e, true);
  }
}

function* paymentCardSaga() {
  yield all([
    takeLatest(FETCH_PAYMENT_CARD_CREATE_REQUEST, fetchPaymentCardCreateSaga),
    takeLatest(FETCH_PAYMENT_CARD_CONFIRM_REQUEST, fetchPaymentCardConfirmSaga),
    takeLatest(FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_REQUEST, fetchPaymentCardAuthSaga),
  ]);
}

export default paymentCardSaga;
